// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__1b7G8","rotate":"CaptureVisa_style_rotate__FaCvR"};